import { render, staticRenderFns } from "./ConcessionPermitTypeTable.vue?vue&type=template&id=e2c545b4"
import script from "./ConcessionPermitTypeTable.vue?vue&type=script&lang=ts"
export * from "./ConcessionPermitTypeTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports